<template>

  <div>
    <vs-row>
      <vs-col
        vs-sm="12"
        vs-lg="4"
        class="p-2"
      >
        <vs-card class="content_mb_0 mb-0 h-full">
          <img src="@/assets/images/gocardless-logo.png" alt="logo">
          <vs-row>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input
                class="custom_Input"
                label="Access Token"
                icon-pack="feather"
                icon="icon-edit"
                icon-after
                
                style="width: 100%"
              
                v-model="gc_access_token"
              />
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>

      <vs-col
        vs-sm="12"
        vs-lg="4"
        class="p-2"
      >
        <vs-card class="content_mb_0 mb-0 h-full">
          <img src="@/assets/images/Paypal-logo.png" alt="logo">
          <vs-row>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input
                class="custom_Input"
                label="Client ID"
                icon-pack="feather"
                icon="icon-edit"
                icon-after
                
                style="width: 100%"
                
                v-model="client_id"
              />
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>

      <vs-col
        vs-sm="12"
        vs-lg="4"
        class="p-2"
      >
        <vs-card class="content_mb_0 mb-0 h-full">
          <img src="@/assets/images/Stripe_Logo.png" alt="logo">
          <vs-row>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input
                class="custom_Input"
                label="Key"
                icon-pack="feather"
                icon="icon-edit"
                icon-after
                
                style="width: 100%"
                
                v-model="stripe_key"
              />

              <vs-input
                class="custom_Input"
                label="Secret"
                icon-pack="feather"
                icon="icon-edit"
                icon-after
              
                style="width: 100%"
                
                v-model="stripe_secret"
              />
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>

    <vs-divider />
    
    <div class="flex flex-1 justify-center">
      <vs-button @click="setGatewaySettings">Save Changes</vs-button>
    </div>
  </div>

</template>

<script>
import { getPaymentGatewaySettings, createPaymentGatewaySettings } from '@/api/common'

export default {
  name: 'UserSettingsPaymentsGateway',
  data () {
    return {
      customer_id: localStorage.getItem('customer_id'),
      gc_access_token: null,
      stripe_key: null,
      stripe_secret: null,
      client_id: null
    }
  },
  mounted () {
    this.getGatewaySettings()
  },
  methods: {
    async getGatewaySettings () {
      try {
        const response = await getPaymentGatewaySettings(this.customer_id)
        if (response.status === 200) {
          const details = response.data.data.payment_details

          this.gc_access_token = details.gc_access_token
          this.stripe_key = details.stripe_key
          this.stripe_secret = details.stripe_secret
          this.client_id = details.client_id
        }
      } catch (e) {
        console.log(e)
      }
    },
    async setGatewaySettings () {
      try {
        const payload = {
          gc_access_token: this.gc_access_token,
          stripe_key: this.stripe_key,
          stripe_secret: this.stripe_secret,
          client_id: this.client_id
        }

        const response = await createPaymentGatewaySettings(this.customer_id, payload)
        if (response.status === 200) {
          this.showSuccessMessage('Success', 'Gateway settings saved successfully', 'success')
        }
      } catch (e) {
        console.log(e)
        this.showSuccessMessage('Error', e.data.message, 'danger')
      }
    }
  }
}
</script>